<template>
  <b-card>
    <b-row>
      <b-col>
        <b-form-group id="input-group-1" label="نام:" label-for="input-1">
          <div class="form-control">
            {{
              uc.user_owner.fa_name != null ? uc.user_owner.fa_name + " " + uc.user_owner.fa_family : ""
            }}
          </div>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="input-group-1" label="نام پدر:" label-for="input-1">
          <div class="form-control">{{ uc.user_owner.fa_father }}</div>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="input-group-1" label="کد ملی:" label-for="input-1">
          <div class="form-control">
            {{ uc.user_owner.national_card_number }}
          </div>
        </b-form-group>
      </b-col>
      <b-col v-if="uc.type.id != 1501 && uc.type.id != 1502 && uc.type.id != 1503">
        <b-form-group id="input-group-1" :label="uc.type.id == 1505
          ? 'بارگذاری سلفی به همراه کارت ملی:'
          : uc.type.id == 1506
            ? 'بارگذاری کارت ملی:'
            : 'بارگذاری مجوز کسب و کار:'
          " label-for="input-1">
          <FileUploader v-model="idup"></FileUploader>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row align-v="center">
      <b-col cols="6">
        <b-form-group id="input-group-1" label="توضیحات:" label-for="input-1">
          <!-- <div class="form-control">
            {{ uc.description[0]!=null ? uc.description[0].description : '' }}
          </div> -->
          <b-form-input v-model="description"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <a target="_blank" :href="uc.fileUrl">
          <b-img fluid :src="uc.fileUrl"></b-img>
        </a>
      </b-col>
    </b-row>
    <b-row class="pt-5">
      <b-col>
        <b-button variant="success" @click="confirm()">تایید</b-button>
        <b-button class="ml-3" variant="danger" @click="unConfirm()">عدم تایید</b-button>
        <b-button v-if="uc.type.id != 1501 && uc.type.id != 1502 && uc.type.id != 1503" class="ml-3" variant="primary"
          @click="update()">بروزرسانی</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import httpHelper from "@/helpers/httpHelper";
import routesMap from "@/helpers/routesMap";
import FileUploader from "@/components/fileUploader2";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { UPDATE_USER_CONF } from "@/core/services/store/updateUserConf.module";

export default {
  name: "EditUserConf",
  data() {
    return {
      uc: {
        user_owner: {
          fa_name: null,
          fa_family: null,
          fa_father: null,
          national_card_number: null,
        },
        type: {
          id: null,
        },
      },
      idup: "",
      description: null,
      routesMap,
    };
  },
  mounted() {
    this.getUserConf();
  },
  methods: {
    unConfirm() {
      var conf = {
        id: this.uc.id,
        mdid7_status: 1520,
        description: this.description,
        isUpdate: true,
      };
      httpHelper
        .postData("userconf", conf)
        .then((res) => {
          res.success == true
            ?
            this.$router.push(
              { path: "/ClientDetails/" + this.uc.user_id + "#userconfirm", query: { from: "unConfirm" } }
            )
            : this.$makeToast(
              "danger",
              "خطا",
              "عدم تایید با خطا مواجه شده است٬لطفا مجددا تلاش نمایید.",
              3000
            );
        })
        .catch(() => {
          this.$makeToast(
            "danger",
            "خطا",
            "خطای سمت سرور رخ داده است.لطفا مجددا تلاش نمایید.",
            3000
          );
        });
    },
    confirm() {
      var conf = {
        id: this.uc.id,
        mdid7_status: 1522,
      };
      httpHelper.postData("userconf", conf).then((res) => {
        res.success == true
          ?
          this.$router.push(
            { path: "/ClientDetails/" + this.uc.user_id + "#userconfirm", query: { from: "Confirm" } }
          )
          : this.$makeToast(
            "danger",
            "خطا",
            "عملیات تایید با خطا مواجه شده است٬لطفا مجددا تلاش نمایید.",
            3000
          );
      })
        .catch(() => {
          this.$makeToast(
            "danger",
            "خطا",
            "خطای سمت سرور رخ داده است.لطفا مجددا تلاش نمایید.",
            3000
          );
        });
    },
    update() {
      let obj = {
        api: "userconf/validate",
        id: this.uc.id,
        mdid6_type: this.uc.mdid6_type,
        mdid7_status: this.uc.mdid7_status,
        confirmCode: this.idup,
      };
      this.$store.dispatch(UPDATE_USER_CONF, obj).then((data) => {
        if (data.success) {
          this.$makeToast(
            "success",
            "بروزرسانی موفق",
            "بروزرسانی با موفقیت انجام گردید.",
            5000
          );
          this.getUserConf();
        } else {
          this.$makeToast(
            "danger",
            "خطا",
            "خطای سمت سرور رخ داده است.لطفا مجددا تلاش نمایید.",
            3000
          );
        }
      });
    },
    async getUserConf() {
      try {
        const res = await httpHelper.getData(`userconf?id=${this.$route.params.id}`);
        this.uc = res.result;
        this.description =
          Array.isArray(this.uc.description) && this.uc.description.length > 0
            ? this.uc.description[0].description
            : null;
        const imageUrl = await httpHelper.getImage(this.uc.value);
        this.$set(this.uc, 'fileUrl', imageUrl.result.url || '');
        const typeTitleMap = {
          1501: "تایید تلفن همراه",
          1502: "تایید پست الکترونیکی",
          1503: "تایید تلغن ثابت",
          1505: "تایید سلفی به همراه کارت ملی",
          1506: "تایید کارت ملی",
        };
        this.$store.dispatch(SET_BREADCRUMB, [
          {
            title: typeTitleMap[this.uc.type.id] || "",
          },
        ]);
      } catch (error) {
        console.error("خطا در دریافت اطلاعات کاربر:", error);
        // می‌توانید پیام خطا به کاربر نمایش دهید
      }
    },
  },
  components: {
    FileUploader,
  },
};
</script>